import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"

import IncidentInfo from "../../components/survey/IncidentInfo"
import SurveyForm from "../../components/survey/SurveyForm"
import EvaluatedComponent from "../../components/survey/EvaluatedComponent"

import { toast } from "react-toastify"

import "./survey.css"

function Home() {
  const [isValidIncident, setValidIncident] = useState(true)
  const [isEvaluated, setIsEvaluated] = useState(null)
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const { o } = useParams()
  const hashId = o

  useEffect(() => {
    async function fetchData() {
      try {
        const url = process.env.REACT_APP_API_URL + "survey/" + hashId
        const response = await axios.get(url)

        if (response.status == 400) {
          setValidIncident(false)
        }

        const { grade } = response.data[0]

        setData(response.data)
        setIsEvaluated(grade == null ? false : true)
        console.log(isEvaluated)
      } catch (error) {
        console.error("Error fetching data:", error)
        setValidIncident(false)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [hashId])

  return isValidIncident ? (
    <div className="survey-wrapper">
      {isLoading ? null : isEvaluated === false ? (
        <>
          <IncidentInfo />
          <SurveyForm />
        </>
      ) : (
        <EvaluatedComponent data={data} />
      )}
    </div>
  ) : (
    <div className="survey-wrapper">
      <div className="msg-form">
        <p>Nenhuma ocorrência encontrada com id "{hashId}"</p>
      </div>
    </div>
  )
}

export default Home
